{
  "Seguimiento del pedido": "Tracciabilità dell'ordine",
  "Enviado": "Spedito",
  "Empaquetado": "Imballato",
  "Recibido": "Ricevuto",
  "Items del pedido": "Articoli dell'ordine",
  "En proceso": "In elaborazione",
  "Devolución solicitada": "Reso richiesto",
  "Devolución en proceso": "Reso in corso",
  "Devuelto": "Restituito",
  "Envío": "Spedizione",
  "Devolución": "Reso",
  "Ver en tienda": "Vedi in negozio",
  "Solicitudes de devolución": "Richieste di reso",
  "Envíos": "Spedizioni",
  "Confirmado": "Confermato",
  "En curso": "In corso",
  "Seguimiento de envío": "Tracciabilità di spedizione",
  "Destino": "Destinazione",
  "Dirección destino": "Indirizzo di destinazione",
  "Última actualización": "Ultimo aggiornamento",
  "Devolución pendiente": "Reso in sospeso",
  "Recogida solicitada": "Ritiro richiesto",
  "Devolución enviada": "Reso inviato",
  "Entrega estimada": "Consegna stimata",
  "Valora tu experiencia con nosotros": "Valuta la tua esperienza con noi",
  "¡Gracias!": "Grazie!",
  "Mensaje de alerta": "Messaggio di avviso",
  "Punto de recogida": "Punto di ritiro",
  "Mostrar historial completo": "Mostra cronologia completa",
  "Ocultar historial": "Nascondi cronologia",
  "¿Necesitas hacer una devolución o cambio?": "Vuoi restituire o cambiare qualcosa?",
  "¿Quieres devolver algo más?": "Vuoi restituire qualcos'altro?",
  "Devuelve o cambia tu artículo en pocos pasos.": "Restituisci o cambia il tuo articolo in pochi semplici passaggi.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "Inizia il processo in pochi passaggi. Ti guideremo durante tutto il percorso.",
  "Abrir el portal de devoluciones": "Vai al portale dei resi",
  "Enviando": "Invio in corso",
  "¡Página no encontrada!": "Pagina non trovata!",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "Spiacenti, non è stato possibile trovare la pagina che stavi cercando",
  "Puedes volver al ": "Puoi tornare all’",
  "principio": "inizio",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "o scriverci a support@reveni.io se non trovi quello che cercavi"
}
